import React, { createContext, useState } from 'react';
import { Constants } from '../constants/constants';
import { products } from '../components/common/staticData/products';

export const StateContext = createContext();

export const StateProvider = ({ children }) => {
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showVideo, setShowVideo] = useState(false);
    const [pageHeader, setPageHeader] = useState('Home');
    const [reqProducts, setReqProducts] = useState([]);
    const [prodProductsLink, setProdProductLink] = useState(products);
    const [isNavMenuClicked, setIsNavMenuClicked] = useState(false);
    const [sessionLogout, setSessionLogout] = useState(false);
    const [allProducts, setAllProducts] = useState([]);
    const [notifBadgeCount, setNotifBadgeCount] = useState(0);
    const [deviceUniqueIdentificationNumber, setDeviceUniqueIdentificationNumber] = useState('');

    //App auth states
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loginData, setLoginData] = useState({
        email: '',
        rememberMe: false,
    });
    const [accessToken, setAccessToken] = useState('');
    const [language, setLanguage] = useState(Constants?.englishLanguage);
    const [showChangePasswordDailog, setShowChangePasswordDailog] = useState(false);
    const [avatarText, setAvatarText] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
     const [autoApprovalRoleIds, setAutoApprovalRoleIds] = useState('');

    const toogleShow = () => {
        setShowAdd(!showAdd);
    };

    const toggleEdit = () => {
        setShowEdit(!showEdit);
    };

    const toggleVideoShow = (value) => {
        setShowVideo(value);
    };

    return (
        <StateContext.Provider
            value={{
                showAdd,
                toogleShow,
                showEdit,
                toggleEdit,
                pageHeader,
                setPageHeader,
                reqProducts,
                setReqProducts,
                showVideo,
                toggleVideoShow,
                prodProductsLink,
                setProdProductLink,
                isNavMenuClicked,
                setIsNavMenuClicked,
                sessionLogout,
                setSessionLogout,
                isAuthenticated,
                setIsAuthenticated,
                loginData,
                setLoginData,
                accessToken,
                setAccessToken,
                language,
                setLanguage,
                showChangePasswordDailog,
                setShowChangePasswordDailog,
                allProducts,
                setAllProducts,
                avatarText,
                setAvatarText,
                name, setName,
                email, setEmail,
                autoApprovalRoleIds, setAutoApprovalRoleIds,
                deviceUniqueIdentificationNumber, setDeviceUniqueIdentificationNumber,
                notifBadgeCount, setNotifBadgeCount,
            }}
        >
            {children}
        </StateContext.Provider>
    );
};